const translations = {
  title: 'Webhook',
  modalTitle: 'Create new Webhook',
  name: 'Name',
  availableUses: 'Available uses',
  enabled: 'Enabled',
  remainingUse: 'Remaining use',
  remainingUses: '{{count}} call',
  remainingUses_plural: '{{count}} calls',
  noLimit: 'No limit',
  url: 'URL',
  conditions: 'Conditions',
  payload: 'Payload',
  details: 'Details',
  calls: 'Calls',
  status: 'Status',
  creationDate: 'Creation date',
  moreDetails: 'More details',
  lessDetails: 'Less details',
  statusCalled: 'Called',
  statusError: 'Error',
  statusSuccess: 'Success',
  'stays.name': 'Name*',
  'stays.maxRequests': 'Maximum requests possible',
  'stays.cancelReason': 'Cancellation reason*',
  'stays.questionnaire': 'Questionnaire*',
  'stays.editTitle': 'Edit stays webhook',
  'stays.newTitle': 'New stays webhook',
  'stays.widgetName': 'Integration with Stays',
  'stays.widgetDescription': 'Create integration with Stays systems',
  'stays.widgetCategory': 'External Communication'
}

export default translations
